import script from "./TopBarV2.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBarV2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__